<template>
  <div>
    <div v-if="loading" class="loading-md bg">
      <i class="fas fa-spinner inner"></i>
      <br />
      <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
        {{ loadingText }}
      </div>
    </div>
    <div v-else class="full">
      <div class="full">
        <div class="mainheader">
            {{ creatingNewEmployee ? $t('employee.core.newEmployee') : $t('employee.core.personalData') }}
        </div>
      </div>
      <div class="third left">
        <div class="full split-bottom-tight">
          <div class="header">
            <div class="label">{{ $t('employee.core.nameAndAddress') }}</div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.firstName') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('firstName')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.firstName" v-bind:style="{color: (savedEmployee.firstName != null && savedEmployee.firstName.length > 0) ? 'var(--contrast-4)' : '#f00'}"/>
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.lastName') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('lastName')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.lastName" v-bind:style="{color: (savedEmployee.lastName != null && savedEmployee.lastName.length > 0) ? 'var(--contrast-4)' : '#f00'}"/>
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.birthdate') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing,mandatory: mandatoryAndMissing('dob')}">
              <input :readonly="!editing" type="date" v-model="dateOfBirth" v-bind:style="{color: (dateOfBirth != null && dateOfBirth.length > 0) ? 'var(--contrast-4)' : '#f00'}"/>
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.birthName') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('maidenName')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.maidenName" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.birthPlace') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('pob')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.pob" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.birthCountry') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('cob')}">
              <!-- lower z-index then selection above ensure above selection overlays this one -->
              <dropdownsearch v-if="editing" style="width: 100%;" class="filters" :state="{
                input: itemsCob.find((s) => s.code === savedEmployee.cob) != undefined ?
                  itemsCob.find((s) => s.code === savedEmployee.cob).label : $t('employee.core.pleaseSelect'),
                items: itemsCob,
                onceSelected: function ($event, item, searchbar){
                  savedEmployee.cob = item.code;
                  checkForPendingChanges();
                },
                selectedItem: itemsCob.find((s) => s.code === savedEmployee.cob),
                styleLight: true,
                style: ''
              }"/>
              <input v-else type="text" :readonly="true" v-model="displayCob"/>
            </div>
          </div>
          <div class="full split-bottom-tight">
            <div class="half left">
              <div class="label">{{ $t('global.ui.siNumber') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('socialsecurity')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.socialsecurity" v-bind:style="!$parent.isSvnrValid(savedEmployee) ? {color: 'var(--col-danger)'} :
                    (!$parent.svnrDuplicates.includes(savedEmployee.socialsecurity ? savedEmployee.socialsecurity.replace(/\s/g, '') : '') ? {} : {color: 'var(--col-info)'})"
              />
            </div>
          </div>

          <div class="full split-bottom-tight">
            <div class="half left">
              <div class="label">{{ $t('employee.core.gender') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('gender')}">
              <dropdownsearch v-if="editing" style="width: 100%;" class="filters" :state="{
                input: genderArray.find((s) => s.id === savedEmployee.genderId) != undefined ?
                  genderArray.find((s) => s.id === savedEmployee.genderId).valueGER : $t('employee.core.notSpecified'),
                items: genderArray,
                onceSelected: function ($event, item, searchbar){
                  savedEmployee.genderId = item.id;
                  checkForPendingChanges();
                },
                selectedItem: genderArray.find((s) => s.id === savedEmployee.genderId),
                styleLight: true,
              }"/>
              <input v-else type="text" :readonly="true" v-model="displayGender" v-bind:style="{color: savedEmployee.genderId != 0 ? 'var(--contrast-4)' : '#f00'}"/>
            </div>
          </div>

          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.citizen') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('citizenship')}">
              <!-- lower z-index then selection above ensure above selection overlays this one -->
              <dropdownsearch v-if="editing" style="width: 100%;" class="filters" :state="{
                input: itemsCitizenship.find((s) => s.code === savedEmployee.citizenshipId) != undefined ?
                  itemsCitizenship.find((s) => s.code === savedEmployee.citizenshipId).label : $t('employee.core.pleaseSelect'),
                items: itemsCitizenship,
                onceSelected: function ($event, item, searchbar){
                  savedEmployee.citizenshipId = item.code;
                  checkForPendingChanges();
                },
                selectedItem: itemsCitizenship.find((s) => s.code === savedEmployee.citizenshipId),
                styleLight: true,
                style: ''
              }"/>
              <input v-else type="text" :readonly="true" v-model="displayCitizenship"/>
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.citizenType') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('citizenTypeId')}">
              <dropdownsearch v-if="editing" style="width: 100%;" class="filters" :state="{
                input: itemsCitizenType.find((s) => s.id === savedEmployee.citizenTypeId) != undefined ?
                  itemsCitizenType.find((s) => s.id === savedEmployee.citizenTypeId).valueGER : $t('employee.core.notSpecified'),
                items: itemsCitizenType,
                onceSelected: function ($event, item, searchbar){
                  savedEmployee.citizenTypeId = item.id;
                  checkForPendingChanges();
                },
                selectedItem: itemsCitizenType.find((s) => s.id === savedEmployee.citizenTypeId),
                styleLight: true,
                style: '',
              }"/>
              <input v-else type="text" :readonly="true" v-model="displayCitizenType"/>
            </div>
          </div>
          <div class="full split-bottom-tight">
            <div class="half left">
              <div class="label">{{ $t('employee.core.maritalStatus') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('civilStatusId')}">
              <dropdownsearch v-if="editing" style="width: 100%;" class="filters" :state="{
                input: itemsCivilStatus.find((s) => s.id === savedEmployee.civilStatusId) != undefined ?
                  itemsCivilStatus.find((s) => s.id === savedEmployee.civilStatusId).valueGER : $t('employee.core.notSpecified'),
                items: itemsCivilStatus,
                onceSelected: function ($event, item, searchbar){
                  savedEmployee.civilStatusId = item.id;
                  checkForPendingChanges();
                },
                selectedItem: itemsCivilStatus.find((s) => s.id === savedEmployee.civilStatusId),
                styleLight: true,
                style: '',
              }"/>
              <input v-else type="text" :readonly="true" v-model="displayCivilStatus"/>

            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.address') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('address')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.address" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.postalCode') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('postalCode')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.postalCode" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.city') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('city')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.city" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.country') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('country')}">
              <!-- lower z-index then selection above ensure above selection overlays this one -->
              <dropdownsearch v-if="editing" style="width: 100%;" class="filters" :state="{
                input: itemsCountry.find((s) => s.code === savedEmployee.countryId) != undefined ?
                  itemsCountry.find((s) => s.code === savedEmployee.countryId).label : $t('employee.core.pleaseSelect'),
                items: itemsCountry,
                onceSelected: function ($event, item, searchbar){
                  savedEmployee.countryId = item.code;
                  checkForPendingChanges();
                },
                selectedItem: itemsCountry.find((s) => s.code === savedEmployee.countryId),
                styleLight: true,
                style: ''
              }"/>
              <input v-else type="text" :readonly="true" v-model="displayCountry"/>
            </div>
          </div>
        </div>

        <div class="full split-bottom-tight">
          <div class="header">
            <div class="label">{{ $t('employee.core.contact') }}</div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.email') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('email')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.email" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.phone') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('homephone')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.homephone" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.mobile') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('mobilephone')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.mobilephone" />
            </div>
          </div>
        </div>
      </div>
      <div class="third mid no-float">
        <div class="full split-bottom-tight">
          <div class="header">
            <div class="label">{{ $t('employee.core.employmentInfo') }}</div>
          </div>
          <div class="full split-bottom-tight">
            <div class="full">
              <div class="half left">
                <div class="label">{{ $t('settings.centers.location')  + '  '}} <small>({{ $t('employee.core.mainStore') }})</small></div>
              </div>
              <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('storeId')}">
                <dropdownsearch v-if="editing" style="width: 100%;" class="filters" :state="{
                  input: storesArray.find((s) => s.id === savedEmployee.storeId) != undefined ? storesArray.find((s) => s.id === savedEmployee.storeId).name : $t('employee.core.pleaseSelect'),
                  items: storesArray,
                  onceSelected: function ($event, item, searchbar){
                    savedEmployee.storeId = item.id;
                    checkForPendingChanges();
                  },
                  selectedItem: storesArray.find((s) => s.id === savedEmployee.storeId),
                  styleLight: true,
                  style: '',
                }"/>
                <input v-else type="text" :readonly="true" v-model="displayStore" v-bind:style="!savedEmployee.storeId ? {color: 'var(--col-info)'} : {}" />
              </div>
            </div>
            <div class="full">
              <div class="half left">
                <div class="label">{{ $t('comp.ui.costCenter')}}</div>
              </div>
              <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('costCenterId')}">
                <dropdownsearch v-if="editing" style="width: 100%;" class="filters" :state="{
                  input: costCenterArray.find((c) => c.id === savedEmployee.costCenterId) != undefined ? costCenterArray.find((c) => c.id === savedEmployee.costCenterId).name : $t('employee.core.pleaseSelect'),
                  items: costCenterDisplayArray,
                  onceSelected: function ($event, item, searchbar){
                    savedEmployee.costCenterId = item.id;
                    checkForPendingChanges();
                  },
                  selectedItem: costCenterDisplayArray.find((c) => c.id === savedEmployee.costCenterId),
                  styleLight: true,
                  style: '',
                }"/>
                <input v-else type="text" :readonly="true" v-model="displayCostCenter" v-bind:style="costCenterArray.find(c => c.id === savedEmployee.costCenterId) ?
                    (costCenterArray.find(c => c.id === savedEmployee.costCenterId).deleted_at == null
                      ? (costCenterArray.find(c => c.id === savedEmployee.costCenterId).isVisible ? {} : {color: 'var(--col-info)'}) : {color: 'var(--col-error)'}) : {}"
                />
              </div>
            </div>
            <div class="full">
              <div class="half left">
                <div class="label">{{ $t('employee.core.externalEmployee') }}</div>
              </div>
              <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('external')}">
                <checkbox :value="savedEmployee.external" @Update="savedEmployee.external = !savedEmployee.external" :disabled="!editing" />
              </div>
            </div>
          </div>
          <div class="full split-bottom-tight">
            <div class="full">
              <div class="half left">
                <div class="label">{{ $t('employee.core.employmentModel') }}</div>
              </div>
              <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('employmentModelId')}">
                <dropdownsearch v-if="editing" style="width: 100%;" class="filters" :state="{
                  input: employmentModelsArray.find((s) => s.id === savedEmployee.employmentModelId) != undefined ? employmentModelsArray.find((s) => s.id === savedEmployee.employmentModelId).name : $t('global.ui.notAssigned'),
                  items: employmentModelsArray,
                  onceSelected: function ($event, item, searchbar){
                    savedEmployee.employmentModelId = item.id;
                    checkForPendingChanges();
                  },
                  selectedItem: employmentModelsArray.find((s) => s.id === savedEmployee.employmentModelId),
                  styleLight: true,
                  style: '',
                }"/>
                <input v-else type="text" :readonly="true" v-model="displayEmploymentModels"/>
              </div>
            </div>

            <div class="full">
              <div class="half left">
                <div class="label">{{ $t('employee.core.payrollGroup') }}</div>
              </div>
              <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('allocationGroup')}">
                <input :readonly="!editing" type="text" v-model="savedEmployee.allocationGroup" />
              </div>
            </div>
          </div>

          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.personalNumberFreeText') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('mdPersonnelId')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.mdPersonnelId" v-bind:style="!$parent.mdPersonnelIdDuplicates.includes(savedEmployee.mdPersonnelId) ? {} : {color: 'var(--col-info)'}" />
            </div>
          </div>
          <div class="full" v-if="showBmdIdField">
            <div class="half left">
              <div class="label">BMD ID</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('bmdId')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.bmdId" />
            </div>
          </div>
          <div class="full split-bottom-tight">
            <div class="half left">
              <div class="label">{{ $t('employee.core.taxId') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('taxId')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.taxId" />
            </div>
          </div>

          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.firstEntryDate') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('workEntryDate')}">
              <input :readonly="!editing" type="date" v-model="savedEmployee.workEntryDate" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.rehire') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('rehire')}">
              <checkbox :value="savedEmployee.rehire" @Update="savedEmployee.rehire = !savedEmployee.rehire" :disabled="!editing" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.workExperienceMonths') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('workExperience')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.workExperience" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.nonEmploymentMonths') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('nonEmploymentTime')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.nonEmploymentTime" />
            </div>
          </div>
        </div>
      </div>
      <div class="third right no-float">
        <div class="full split-bottom-tight">
          <div class="header">
            <div class="label">{{ $t('employee.core.bankAccount') }}</div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.accountHolder') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('bankAccountHolder')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.bankAccountHolder" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">IBAN</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('iban')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.iban"
                v-bind:style="!$parent.isIbanValid(savedEmployee.iban) ? {color: 'var(--col-danger)'} :
                  (!$parent.ibanDuplicates.includes(savedEmployee.iban ? savedEmployee.iban.replace(/\s/g, '') : '') ? {} : {color: 'var(--col-info)'})"
              />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">BIC</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('bic')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.bic" />
            </div>
          </div>
        </div>

        <div class="full split-bottom-tight">
          <div class="header">
            <div class="label">{{ $t('employee.core.emergencyContact') }}</div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('settings.groups.name') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('guardianName')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.guardianName" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.relationship') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('guardianRelationship')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.guardianRelationship" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.address') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('guardianAddress')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.guardianAddress" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.phone') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('guardianPhone')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.guardianPhone" />
            </div>
          </div>
        </div>

        <div class="full split-bottom-tight">
          <div class="header">
            <div class="label">{{ $t('employee.core.additionalInfo') }}</div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.miscInfo') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('miscInfo')}">
              <input :readonly="!editing" type="text" v-model="savedEmployee.miscInfo" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.disability50') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('disability')}">
              <checkbox :value="savedEmployee.disability" @Update="savedEmployee.disability = !savedEmployee.disability" :disabled="!editing" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.driversLicense') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('driverslicense')}">
              <checkbox :value="savedEmployee.driverslicense" @Update="savedEmployee.driverslicense = !savedEmployee.driverslicense" :disabled="!editing" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.driversLicenseExpiry') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('dlExpiry')}">
              <input :readonly="!editing" type="date" v-model="savedEmployee.dlExpiry" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.firstAidCourse') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('firstaidcourse')}">
              <checkbox :value="savedEmployee.firstaidcourse" @Update="savedEmployee.firstaidcourse = !savedEmployee.firstaidcourse" :disabled="!editing" />
            </div>
          </div>
          <div class="full">
            <div class="half left">
              <div class="label">{{ $t('employee.core.firstAidCourseExpiry') }}</div>
            </div>
            <div class="half cd-input" v-bind:class="{roinput: !editing, mandatory: mandatoryAndMissing('faExpiry')}">
              <input :readonly="!editing" type="date" v-model="savedEmployee.faExpiry" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dropdownsearch from "../uicomponents/dropdownsearch.vue";
import {mapGetters} from "vuex";

export default {
  components: {
    dropdownsearch,
  },
  name: "employeecoredata",
  data() {
    return {
      storesArray: [],
      costCenterDisplayArray: [],
      employmentModelsArray: [],

      dataFiltered: [],
      loading: true,
      loadingText: this.$t('employee.core.dataUpdating'),
      dragWatch: -1,
      mouseCurrent: {
        x: 0,
        y: 0,
      },
      mouseDragStart: {
        x: 0,
        y: 0,
      },
      scrolling: false,
      scrollTop: 150,
      dropdowns: [],
      savedEmployee: {},
      pendingChanges: false,
      editing: false,
    };
  },
  watch: {
    savedEmployee: {
      deep: true,
      handler(val, old) {
        if (val.storeId == null || val.storeId == undefined) {
          val.storeId = 0;
        }
        if (val.employmentModelId == null || val.employmentModelId == undefined) {
          val.employmentModelId = 0;
        }
        if (val.genderId == null || val.genderId == undefined) {
          val.genderId = 0;
        }
        if (val.countryId == null || val.countryId == undefined) {
          val.countryId = 0;
        }
        if (val.citizenshipId == null || val.citizenshipId == undefined) {
          val.citizenshipId = 0;
        }
        if (val.cob == null || val.cob == undefined) {
          val.cob = 0;
        }
        if (val.external == null || val.external == undefined) {
          val.external = false;
        }
        if (val.rehire == null || val.rehire == undefined) {
          val.rehire = true;
        }
        if (val.disability == null || val.disability == undefined) {
          val.disability = false;
        }
        if (val.driverslicense == null || val.driverslicense == undefined) {
          val.driverslicense = false;
        }
        if (val.firstaidcourse == null || val.firstaidcourse == undefined) {
          val.firstaidcourse = false;
        }

        this.checkForPendingChanges();
      },
    },
    nameFilter: function (val, oldVal) {
      if (val === "") {
        this.dataFiltered = this.gridData.data.slice();
        return;
      }
      this.dataFiltered = this.gridData.data.filter((e) => (e.firstName.toLowerCase() + " " + e.lastName.toLowerCase()).indexOf(val.toLowerCase()) > -1);
    },
    employee: function (val, oldVal) {
      this.editing = this.creatingNewEmployee;
      this.savedEmployee = Object.assign({}, this.employee);
      if (this.creatingNewEmployee) {
        console.log("savedEmployee created:", this.savedEmployee);
        console.log("employee prop:", this.employee);
      }
    },
  },
  props: ["employee", "creatingNewEmployee", "companyData"],
  computed: {
      ...mapGetters([
        "storeMap",
        "countryEnumMap",
        "genderEnumMap",
        "citizentypeEnumMap",
        "civilstatusEnumMap",
        "costCenterArray"
      ]),
      mandatoryFields(){
        let mandatoryFields = ['firstName', 'lastName', 'email', 'dob' ];
        if(this.companyData && this.companyData.id == 116){
          mandatoryFields.push('mdPersonnelId')
        }
        return mandatoryFields;
      },
    dateOfBirth: {
      get: function () {
        var dateStr;
        if (this.savedEmployee.dob) {
          dateStr = this.$helpers.extractDateString(this.savedEmployee.dob);
        }
        return dateStr;
      },
      set: function (val) {
        this.savedEmployee.dob = this.$helpers.convertDateTimeStringUTC(val);
      },
    },
    genderArray() {
      return Object.values(this.genderEnumMap).map(c => {
        return {id: c.id, code: c.id, value: c.id, label: this.$t(`enum.gender.${c.id}`), name: this.$t(`enum.gender.${c.id}`)};
      });
    },
    displayGender: {
      get: function () {
        var str = this.$t('employee.core.notSpecified');
        if (this.genderArray.find((s) => s.code === this.savedEmployee.genderId) != undefined) {
          str = this.genderArray.find((s) => s.code === this.savedEmployee.genderId).label;
        }
        return str;
      },
    },
    itemsCountry() {
      return Object.values(this.countryEnumMap).map(c => {
        return {code: c.id, label: this.$t(`enum.country.${c.id}`), name: this.$t(`enum.country.${c.id}`)};
      }).sort((a, b) => a.label.localeCompare(b.label));
    },
    displayCountry: {
      get: function () {
        var str = this.$t('employee.core.notSpecified');
        if (this.itemsCountry.find((s) => s.code === this.savedEmployee.countryId) != undefined) {
          str = this.itemsCountry.find((s) => s.code === this.savedEmployee.countryId).label;
        }
        return str;
      },
    },
    itemsCitizenship() {
      return Object.values(this.countryEnumMap).map(c => {
        return {code: c.id, label: this.$t(`enum.country.${c.id}`), name: this.$t(`enum.country.${c.id}`)};
      }).sort((a, b) => a.label.localeCompare(b.label));
    },
    displayCitizenship: {
      get: function () {
        var str = this.$t('employee.core.notSpecified');
        if (this.itemsCitizenship.find((s) => s.code === this.savedEmployee.citizenshipId) != undefined) {
          str = this.itemsCitizenship.find((s) => s.code === this.savedEmployee.citizenshipId).label;
        }
        return str;
      },
    },
    itemsCob() {
      return Object.values(this.countryEnumMap).map(c => {
        return {code: c.id, label: this.$t(`enum.country.${c.id}`), name: this.$t(`enum.country.${c.id}`)};
      }).sort((a, b) => a.label.localeCompare(b.label));
    },
    displayCob: {
      get: function () {
        var str = this.$t('employee.core.notSpecified');
        if (this.itemsCob.find((s) => s.code === this.savedEmployee.cob) != undefined) {
          str = this.itemsCob.find((s) => s.code === this.savedEmployee.cob).label;
        }
        return str;
      },
    },
    displayStore: {
      get: function () {
        var str = this.$t('global.ui.notAssigned');
        if (this.storesArray.find((s) => s.id === this.savedEmployee.storeId) != undefined) {
          str = this.storesArray.find((s) => s.id === this.savedEmployee.storeId).name;
        }
        return str;
      },
    },
    displayCostCenter: {
      get: function () {
        var str = this.$t('global.ui.notAssigned');
        if (this.costCenterArray.find((s) => s.id === this.savedEmployee.costCenterId) != undefined) {
          str = this.costCenterArray.find((s) => s.id === this.savedEmployee.costCenterId).name;
        }
        return str;
      },
    },
    displayEmploymentModels: {
      get: function () {
        var str = this.$t('global.ui.notAssigned');
        if (this.employmentModelsArray.find((s) => s.id === this.savedEmployee.employmentModelId) != undefined) {
          str = this.employmentModelsArray.find((s) => s.id === this.savedEmployee.employmentModelId).name;
        }
        return str;
      },
    },
    itemsCitizenType() {
      return Object.values(this.citizentypeEnumMap).map(c => {
        return {id: c.id, code: c.id, value: c.key, label: this.$t(`enum.citizenType.${c.id}`), name: this.$t(`enum.citizenType.${c.id}`)};
      });
    },
    displayCitizenType: {
      get: function () {
        var str = this.$t('employee.core.notSpecified');
        if (this.itemsCitizenType.find((s) => s.id === this.savedEmployee.citizenTypeId) != undefined) {
          str = this.itemsCitizenType.find((s) => s.id === this.savedEmployee.citizenTypeId).label;
        }
        return str;
      },
    },
    itemsCivilStatus() {
      return Object.values(this.civilstatusEnumMap).map(c => {
        return {id: c.id, code: c.id, value: c.key, label: this.$t(`enum.civilStatus.${c.id}`), name: this.$t(`enum.civilStatus.${c.id}`)};
      });
    },
    displayCivilStatus: {
      get: function () {
        var str = this.$t('employee.core.notSpecified');
        if (this.itemsCivilStatus.find((s) => s.id === this.savedEmployee.civilStatusId) != undefined) {
          str = this.itemsCivilStatus.find((s) => s.id === this.savedEmployee.civilStatusId).label;
        }
        return str;
      },
    },
    showBmdIdField() {
      let view = this;
      if (view.companyData != null && view.companyData.softwareId === 0
          && view.employee.bmdId !== -1 && String(view.employee.bmdId) !== String(view.employee.mdPersonnelId)) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    let view = this;
    console.log("Mounted EmployeeCoreData");

    this.loading = true;

    let promises = [];
    let url = "/sec/employmentModels";
    promises.push(this.api.get(url).then((response) => {
      view.employmentModelsArray.push({ id: 0, label: view.$t('global.ui.notAssigned'), name: view.$t('global.ui.notAssigned') });
      for (let x in response.data.data) {
        let elem = response.data.data[x];
        elem.label = elem.name;
        view.employmentModelsArray.push(elem);
      }
    }));

    this.savedEmployee = Object.assign({}, this.employee);
    this.editing = this.creatingNewEmployee;

    view.storesArray = [{ id: 0, label: view.$t('global.ui.notAssigned'), name: view.$t('global.ui.notAssigned') }];
    Object.values(this.storeMap).forEach(s => {
      s.label = s.name;
      this.storesArray.push(s);
    });

    view.costCenterDisplayArray = [{ id: 0, label: view.$t('global.ui.notAssigned'), name: view.$t('global.ui.notAssigned') }];
    this.costCenterArray.filter(c => c.isVisible).forEach(s => {
      s.label = s.name;
      view.costCenterDisplayArray.push(s);
    });
    view.costCenterDisplayArray = view.costCenterDisplayArray;
    // console.log("costCenterDisplayArray", view.costCenterDisplayArray);

    Promise.all(promises)
      .then(response => {
        view.$forceUpdate();
        console.log("loading done");
        this.loading = false;
      });
  },
  destroyed() {},
  methods: {
    toggleEditMode() {
      this.editing = !this.editing;
    },
    cancelEditMode() {
      this.savedEmployee = Object.assign({}, this.employee);
      this.editing = false;
      if (this.creatingNewEmployee) {
        this.$emit("employee-creation-cancelled");
      } else {
        this.$emit("employee-edit-cancelled");
      }
    },
    mandatoryAndMissing(key) {
      let specialGermanCompanies = [116, 136, 137];
      if (this.mandatoryFields.includes(key)) {
        if(this.companyData && specialGermanCompanies.includes(this.companyData.id) && key == 'personnelId'){
          let value = this.savedEmployee[key]
          let isMissing = this.$helpers.isEmpty(value);
          let isNum = true;
          if(!isMissing){
            isNum = /^\d+$/.test(value);
          }
          return isMissing || !isNum;
        } else {
          return this.$helpers.isEmpty(this.savedEmployee[key])
        }
        //return true;
      }
      return false;
    },
    checkForPendingChanges() {
      var keys = Object.keys(this.savedEmployee);
      var changedKeys = [];
      keys.forEach((key) => {
        if (key != "metadata") {
          // metadata is calculated employee state date added for frontend purpopses only
          if (!(key in this.employee) || this.savedEmployee[key] != this.employee[key]) {
            changedKeys.push(key);
          }
        }
      });
      this.pendingChanges = changedKeys.length > 0;
      return changedKeys;
    },
    itemWithId(id, arr) {
      for (const item of arr) {
        if (item.id == id) return item;
      }
      // fallback, should not happen
      return { id: "", name: "", label: "" };
    },
    Init(items, config) {},
    gender(code) {
      switch (code) {
        case "m":
        case "M":
          return this.$t('employee.core.male');
        case "f":
        case "F":
          return this.$t('employee.core.female');
        default:
          return this.$t('employee.core.human');
      }
    },
    updateChangedFields(generateChangePdf = false) {
      this.loadingText = this.$t('employee.comp.dataSaving');
      var changedKeys = this.checkForPendingChanges();
      let payload = {};
      this.loading = true;
      changedKeys.forEach((key) => {
        let val = this.savedEmployee[key];
        switch (key) {
          case "dob":
            val = this.$helpers.extractDateString(val);
            break;
        }
        payload[key] = val;
      });
      console.log(payload);
      if (changedKeys.length > 0) {
        let view = this;
        var keys = [];
        changedKeys.forEach((key) => {
          if (key != "metadata") {
            // metadata is only calculated info added for frontend
            keys.push(key);
          }
        });
        if (keys.length > 0) {
          let url = "/sec/employee/coredata/" + this.savedEmployee.id;
          console.log(payload);
          this.api
            .put(url, payload)
            .then((response) => {
              console.log(response);
              if (response.status == 200) {
                view.$helpers.success(view.$t('employee.core.saved'), view.$t('employee.core.changesSaved'));
                keys.forEach((key) => {
                  this.employee[key] = this.savedEmployee[key];
                });
                view.$emit("updated", view.employee.id, true);
                view.checkForPendingChanges();
                view.$forceUpdate();
              }
              this.loading = false;
              view.editing = false;
            })
            .catch(function (error) {
              view.loading = false;
              console.log(error);
              console.log(error.message);
              view.$helpers.error(error.message);
            });
        }
      }
    },
    createEmployee() {
      this.$helpers.log(this, "createEmployee", this.employee);
      this.getCandidates(this.savedEmployee).then((response) => {
        let candidatesResponse = response.data.data;
        console.log(candidatesResponse);
        let selectableItems = this.transformCandidateResult(candidatesResponse);
        if (selectableItems.length > 0) {
          this.openCandidateChooserPopup(this.savedEmployee, selectableItems).then((remoteId) => {
            if (remoteId != null) {
              // employee exists
              this.$emit("select-employee-id", remoteId);
            } else {
              this.saveEmployee(this.savedEmployee);
            }
          });
        } else {
          this.saveEmployee(this.savedEmployee);
        }
      });
      //this.$emit('create-employee', this.savedEmployee);
    },
    saveEmployee(employee) {
      let view = this;
      console.log("Ready to save!");
      console.log(employee);
      let payload = employee;
      payload.dob = this.$helpers.extractDateString(payload.dob);

      // TODO: main store selection
      let url = "/sec/employee/coredata";
      this.api.post(url, payload).then((response) => {
        console.log(response);
        if (response.status == 200) {
          view.$helpers.success(view.$t('employee.core.saved'), view.$t('employee.core.employeeSaved'));
          view.toggleEditMode();
          view.creatingNewEmployee = false;
          view.$emit("create-employee", response.data);
          view.checkForPendingChanges();
          view.$forceUpdate();
        }
        view.editing = false;
      });
    },
    getCandidates(employee) {
      let url = "/sec/employee/proxyMDCoreCandidate";
      url = this.$helpers.appendParam("firstName", employee.firstName, url, "/sec/employee/proxyMDCoreCandidate");
      url = this.$helpers.appendParam("lastName", employee.lastName, url, "/sec/employee/proxyMDCoreCandidate");
      if (employee.dob != null) url = this.$helpers.appendParam("dob", this.$helpers.extractDateString(employee.dob), url, "/sec/employee/proxyMDCoreCandidate");
      if (employee.socialsecurity != null) url = this.$helpers.appendParam("socialsecurity", employee.socialsecurity, url, "/sec/employee/proxyMDCoreCandidate");
      console.log(url);
      return this.api.get(url);
    },
    transformCandidateResult(candidateResult) {
      let candidates = candidateResult.candidates;
      let matches = candidateResult.matches;
      let selectableItems = [];
      candidates.forEach((candidate) => {
        let bd = candidate.date_of_birth != null ? this.$helpers.getMomentFromStringTZ(candidate.date_of_birth).format("DD.MM.YYYY") : "";
        let item = {
          label: candidate.firstname + " " + candidate.lastname + " " + bd + " (" + this.$t('employee.core.match') + ": " + candidate.score + "%)",
          value: candidate.id,
          score: candidate.score,
        };
        selectableItems.push(item);
      });
      matches.forEach((candidate) => {
        let bd = candidate.date_of_birth != null ? this.$helpers.getMomentFromStringTZ(candidate.date_of_birth).format("DD.MM.YYYY") : "";
        let item = {
          label: candidate.firstname + " " + candidate.lastname + " " + bd + " 100%",
          value: candidate.id,
          score: 100,
        };
        selectableItems.push(item);
      });
      selectableItems.sort((a, b) => {
        return -(a.score - b.score);
      });
      return selectableItems;
    },
    openCandidateChooserPopup(newEmployee, selectableItems) {
      let view = this;
      let entries = [];

      selectableItems.unshift({
        label: view.$t('employee.core.createNewEmployee'),
        value: null,
      });

        let description =
            view.$t('employee.core.similarEmployeesFound') +
            " <br/> " +
            view.$t('employee.core.createOrSelectEmployee');

      entries.push({
        label: view.$t('settings.wage.pleaseSelect'),
        key: "remoteId",
        hidden: false,
        type: "dropdownsearch",
        value: null,
        selectMultiple: false,
        dropdownSearchState: {
          toggled: false,
          displayedItems: [],
          input: "",
          items: selectableItems,
          selectMultiple: false,
          selectedItems: [],
          selectFirst: true,
          styleLight: true,
        },
      });

      return new Promise((resolve, accept) => {
        view.$helpers.OpenPopup({
          type: "datafill",
          componentState: {
            entries: entries,
            description: description,
            selectCallback: function (item) {
              resolve(item.remoteId);
            },
          },
          header: view.$t('employee.core.createEmployeeHeader') + ": " + newEmployee.firstName + " " + newEmployee.lastName,
          centered: true,
          expanded: true,
        });
      });
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dropdown-search.filters {
  height: 25px !important;
  margin-top: -4px;
  display: block;
}

.input-component {
  text-align: left;
}

.checkbox-component {
  margin-top: -5px;
}

/*
.content *:not(.main-settings)>.half {
    height: 105px;
}
*/
</style>
